import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

@Index("class", ["class"], {})
@Index("subject", ["subject"], {})
@Index("qno", ["qno"], {})
@Index("marks", ["marks"], {})
@Index("idx_cq_bankview", ["class", "subject", "chapter", "marks", "qno"], {})
@Index("idx_cq_ability", ["class", "subject", "ability", "abilityType"], {})
@Entity("createquestion")
export class CreateQuestion {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("int", { name: "class" })
  class: number;

  @Column("int", { name: "subject" })
  subject: number;

  @Column("int", { name: "chapter" })
  chapter: number;

  @Column("int", { name: "topic", default: 0 })
  topic: number;

  @Column("int", { name: "qno", nullable: true })
  qno: number;

  @Column("longtext", { name: "question", nullable: true })
  question: string;

  @Column("int", { name: "language", nullable: true })
  language: number;

  @Column("float", { name: "marks" })
  marks: number;

  @Column("int", { name: "complexity", nullable: true })
  complexity: number;

  @Column("int", { name: "ability", nullable: true })
  ability: number;

  @Column("int", { name: "ability_type", nullable: true })
  abilityType: number;

  @Column("int", { name: "questiontype", nullable: true })
  questiontype: number;

  @Column("varchar", { name: "has_stimulus", length: 10, nullable: true })
  hasStimulus: string;

  @Column("float", { name: "estimated_time", nullable: true })
  estimatedTime: number;

  @Column("int", { name: "competency_code", nullable: true })
  competencyCode: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @Column("int", { name: "created_by", nullable: true })
  createdBy: number;

  @Column("int", { name: "updated_by", nullable: true })
  updatedBy: number;

  @Column("varchar", { name: "prepared_by", length: 255, nullable: true })
  preparedBy: string;

  @Column("varchar", { name: "mobile_no", length: 20, nullable: true })
  mobileNo: string;

  @Column("varchar", { name: "has_answer_key", length: 5, nullable: true, default: 'No' })
  hasAnswerKey: string;

  @Column("longtext", { name: "answer_key", nullable: true })
  answerKey: string;

  @Column("varchar", { name: "approved_by", length: 255, nullable: true })
  approvedBy: string;

  @Column("datetime", { name: "approved_date", nullable: true })
  approvedDate: Date;

  @Column("varchar", { name: "approval_status", length: 20, default: "PENDING" })
  approvalStatus: string;

  @CreateDateColumn({ name: "created_at", type: "datetime" })
  createdAt: Date;

  @UpdateDateColumn({ name: "updated_at", type: "datetime" })
  updatedAt: Date;
}
